import Icon from '../components/Icon.vue'

Icon.register({"bath":{"width":512,"height":512,"paths":[{"d":"M488 256H80V112C80 94.4 94.4 80 112 80 123.4 80 133.3 85.9 139 94.9 122.5 120.1 124.3 154.5 145.9 177.9 141.7 182.6 141.8 189.8 146.3 194.3L157.7 205.7C162.3 210.3 169.9 210.3 174.6 205.7L269.7 110.6C274.3 105.9 274.3 98.3 269.7 93.7L258.3 82.3C253.8 77.8 246.6 77.7 241.9 81.9 224 65.4 199.6 60.4 177.7 66.5 163.3 45.7 139.2 32 112 32 67.9 32 32 67.9 32 112V256H24C10.7 256 0 266.7 0 280V296C0 309.3 10.7 320 24 320H32V352C32 380.4 44.4 406 64 423.5V456C64 469.3 74.7 480 88 480H104C117.3 480 128 469.3 128 456V448H384V456C384 469.3 394.7 480 408 480H424C437.3 480 448 469.3 448 456V423.5C467.6 406 480 380.4 480 352V320H488C501.3 320 512 309.3 512 296V280C512 266.7 501.3 256 488 256z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/bath.js
// module id = null
// module chunks = 